// extracted by mini-css-extract-plugin
module.exports = {"sponsorsFooter":"sponsors-footer-module--sponsors-footer--c2y0q","list":"sponsors-footer-module--list--2LTrI","sponsor":"sponsors-footer-module--sponsor--23tVN"};